'use client';
import { MANIFEST_IMAGES } from '../manifest/images.js';
import { getSameKeyValueMapForManifest, manifestResolve } from './manifest.utils.js';
import { SwanAssetFolders } from '../types/enums.js';

const SWAN_IMAGE_KEY_MAP = getSameKeyValueMapForManifest(MANIFEST_IMAGES);
function getSwanImageUrl(o, m, i) {
    return manifestResolve(MANIFEST_IMAGES, o, SwanAssetFolders.IMAGES, m, i);
}

export { SWAN_IMAGE_KEY_MAP, getSwanImageUrl };
